// extracted by mini-css-extract-plugin
export default {"textarea":"lsf-textarea","textarea_inline":"lsf-textarea_inline","textarea_autosize":"lsf-textarea_autosize","waiting":"lsf-waiting"};